import { mediaQueries } from '../components/shared/ui/variables'
// import * as R from 'ramda'
import merge from 'deepmerge'

const insertMediaQueries = (key, values) => {
  // return R.mergeAll(
  //   R.flatten(
  //     values.map((value, index) => {
  //       // first element has no media query
  //       if (index === 0) {
  //         return { [key]: value }
  //       }
  //       if (mediaQueries.length > index - 1) {
  //         return {
  //           [mediaQueries[index - 1]]: {
  //             [key]: value
  //           }
  //         }
  //       }
  //       return {}
  //     })
  //   )
  // )
  return values.reduce((generatedMediaQuery, currentValue, index) => {
    if (index === 0) {
      // first element in array style without mediaquery
      generatedMediaQuery[key] = currentValue
      return generatedMediaQuery
    }
    generatedMediaQuery[mediaQueries[index - 1]] = {
      [key]: currentValue
    }
    return generatedMediaQuery
  },                   {})
}

export default function createMediaQueries(css) {
  // no css prop in the component
  if (!css) {
    return {}
  }

  if (typeof css === 'string' || typeof css === 'number') {
    return css
  } else {
    let newCss = {}
    for (const key in css) {
      // if string or number add to property to newCss
      if (typeof css[key] === 'string' || typeof css[key] === 'number') {
        newCss[key] = css[key]
      } else if (Array.isArray(css[key])) {
        // if array apply media queries to styles
        const withMedia = insertMediaQueries(key, css[key])
        newCss = merge.all([newCss, withMedia])
      } else {
        // if object apply media query to object (media query might be in nested objects)
        newCss[key] = createMediaQueries(css[key])
      }
    }
    return newCss
  }
}
